/* eslint-disable max-len */

import * as ScrollMagic from 'scrollmagic';
import { TweenMax, SteppedEase } from 'gsap/all';
import { Component } from '../core/component';

// uncomment next line in addition .addIndicators() to show triggers for debug
/* eslint-disable-next-line */
// import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

export class Animation extends Component {
    constructor() {
        super();
        this.selector = '[data-animation]';
    }

    init() {
        const features = document.querySelectorAll(this.selector);
        let format = 'png';

        // check if the browser supports webp
        async function supportsWebp() {
            if (!self.createImageBitmap) return false;

            const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
            const blob = await fetch(webpData).then(r => r.blob());
            return createImageBitmap(blob).then(() => true, () => false);
        }

        (async () => {
            if (await supportsWebp()) {
                format = 'webp';
            }

            features.forEach((feature) => {
                const containerHeight = feature.offsetHeight > window.innerHeight ? feature.offsetHeight : window.innerHeight;
                const container = feature.querySelector('[data-animation-scene]');

                if (!container) return;

                const customTrigger = container.hasAttribute('data-animation-trigger') ? container.getAttribute('data-animation-trigger') : false;
                const trigger = customTrigger ? Number(customTrigger, 10) : 0.7;

                const animation = container.getAttribute('data-animation-scene');
                container.style.backgroundImage = `url('${global.$app.siteUrl}assets/img/animations/${animation}.${format}')`;

                // set tween
                // 16200px is the width of the sprite.
                // We can't exceed 16300px for webp conversions.
                // 54 is the amount of frames in SteppedEase function
                const tween = TweenMax.to(container, 3, {
                    backgroundPosition: '-16200px',
                    ease: SteppedEase.config(54),
                    repeat: 1,
                });

                // init controller
                const controller = new ScrollMagic.Controller();

                // build scene
                // uncomment .addIndicators to show triggers for debug
                const scene = new ScrollMagic.Scene({
                    triggerElement: feature,
                    duration: containerHeight,
                })
                    .triggerHook(trigger)
                    .setTween(tween)
                    // .addIndicators()
                    .addTo(controller);

                // on scroll update duration height
                window.addEventListener('scroll', () => {
                    const duration = feature.offsetHeight > window.innerHeight ? feature.offsetHeight : window.innerHeight;
                    scene.duration(duration);
                });

                // on resize update duration height
                window.addEventListener('resize', () => {
                    const duration = feature.offsetHeight > window.innerHeight ? feature.offsetHeight : window.innerHeight;
                    scene.duration(duration);
                });
            });
        })();
    }
}
